module.exports = __webpack_public_path__ + "media/images/covid/mask_ico-c5e6dc73f30c0774af3a26323803b515.png";